/**
 * Back to top — ported from live theme (fw-player adjust kept).
 * Vanilla JS: Horizon loads jQuery as type="module", so top-level $ is unsafe.
 */
(function () {
  const btn = document.querySelector('.backgorund-text');
  if (!btn) return;

  let lastScrollTop = 0;

  window.addEventListener(
    'scroll',
    () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > 300 && st < lastScrollTop) {
        btn.classList.add('show');
      } else {
        btn.classList.remove('show');
      }
      lastScrollTop = st;
    },
    { passive: true }
  );

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

(function () {
  let count = 0;

  function waitForFwPlayer(callback) {
    const fwPlayer = document.querySelector('#fw-player');
    // Stop after ~5 polls if the corner video never appears
    if (count > 5 && !fwPlayer) {
      return;
    }
    if (fwPlayer) {
      callback(fwPlayer);
    } else {
      setTimeout(() => {
        waitForFwPlayer(callback);
      }, 200);
    }
    count += 1;
  }

  waitForFwPlayer((fwPlayer) => {
    const arrow = document.querySelector('.backgorund-text .top_button_arrow');
    if (!fwPlayer?.parentNode || !arrow) return;

    arrow.style.bottom = '23rem';

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          if (node instanceof HTMLElement && node.id === 'fw-player') {
            arrow.style.bottom = '15rem';
          }
        });
      });
    });
    observer.observe(fwPlayer.parentNode, { childList: true });
  });
})();
